"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpApplicationInitError = void 0;
const lodash_1 = require("lodash");
const vue_property_decorator_1 = require("vue-property-decorator");
const application_init_error_html_1 = __importDefault(require("./application-init-error.html"));
let ItpApplicationInitError = class ItpApplicationInitError extends vue_property_decorator_1.Vue {
    error;
    data() {
        return getErrorDetails(this.error);
    }
};
exports.ItpApplicationInitError = ItpApplicationInitError;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Error)
], ItpApplicationInitError.prototype, "error", void 0);
exports.ItpApplicationInitError = ItpApplicationInitError = __decorate([
    (0, vue_property_decorator_1.Component)({ template: application_init_error_html_1.default })
], ItpApplicationInitError);
function getErrorDetails(error) {
    const status = (0, lodash_1.get)(error, 'response.status');
    const statusText = (0, lodash_1.get)(error, 'response.statusText');
    const data = (0, lodash_1.get)(error, 'response.data');
    console.log(status, statusText, data, error, (0, lodash_1.isNumber)(status), (0, lodash_1.isString)(statusText), (0, lodash_1.isObject)(data));
    if ((0, lodash_1.isNumber)(status) && (0, lodash_1.isString)(statusText) && (0, lodash_1.isObject)(data)) {
        return {
            errorHeader: `${status} ${statusText}`,
            errorMessage: (0, lodash_1.get)(data, 'detail', `${error.name} - ${error.message}`)
        };
    }
    return {
        message: `${error.name} - ${error.message}`,
        stack: error.stack
    };
}
//# sourceMappingURL=application-init-error.js.map